import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQueryWithReauth } from "../../app/utils"
import {
  CallDataSourceDto,
  CreateCallDataSourceDto,
  OrganizationDto,
  UpdateCallDataSourceDto,
  UpdateOrganizationDto,
} from "@dialogics/shared/dto/types"
import { ListResponse } from "../../app/types.ts"

export const settingsApi = createApi({
  reducerPath: "settingsApi",
  baseQuery: baseQueryWithReauth({ baseUrl: "/api" }),
  tagTypes: ["Organization", "CallDataSource"],
  endpoints: builder => ({
    organization: builder.query<OrganizationDto, number>({
      query: id => `/organization/${id}`,
      providesTags: ["Organization"],
    }),
    updateOrganization: builder.mutation<OrganizationDto, { id: number } & UpdateOrganizationDto>({
      query: ({ id, ...data }) => ({
        url: `/organization/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Organization"],
    }),
    callDataSources: builder.query<ListResponse<CallDataSourceDto>, { organization_id: number }>({
      query: params => `/call-data-source?${new URLSearchParams(params).toString()}`,
      providesTags: ["CallDataSource"],
    }),
    addCallDataSource: builder.mutation<CallDataSourceDto, CreateCallDataSourceDto>({
      query: data => ({
        url: "/call-data-source",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CallDataSource"],
    }),
    updateCallDataSource: builder.mutation<CallDataSourceDto, { id: number } & UpdateCallDataSourceDto>({
      query: ({ id, ...data }) => ({
        url: `/call-data-source/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["CallDataSource"],
    }),
    deleteCallDataSource: builder.mutation<void, number>({
      query: id => ({
        url: `/call-data-source/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["CallDataSource"],
    }),
  }),
})

export const {
  useOrganizationQuery,
  useUpdateOrganizationMutation,
  useCallDataSourcesQuery,
  useAddCallDataSourceMutation,
  useUpdateCallDataSourceMutation,
  useDeleteCallDataSourceMutation,
} = settingsApi
